import React from "react";

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import { Typography } from "@mui/material";

// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";

import "./Styles.css";

// import required modules
import { EffectCoverflow, Pagination } from "swiper";
import SingleProjectCard from "../../../components/Projects/SingleProjectCard";
import lays from "../../../assets/projects/lays.png";
import fitness from "../../../assets/projects/fiteness.png";
import freelance from "../../../assets/projects/freelance.png";
import html from "../../../assets/icons/html.svg";
import css from "../../../assets/icons/css.svg";
import js from "../../../assets/icons/javascript.svg";
import bootsrap from "../../../assets/icons/bootstrap.svg";
import react from "../../../assets/icons/react.svg";
import mui from "../../../assets/icons/material-ui-1.svg";
import mongo from "../../../assets/icons/mongo.svg";
import node from "../../../assets/icons/nodejs.svg";
import tailwind from "../../../assets/icons/tailwind.svg";
import php from "../../../assets/icons/php.svg";
import mysql from "../../../assets/icons/mysql.svg";
import clean from "../../../assets/projects/clean.png";
import keyboard from "../../../assets/projects/keyboard.png";
import game from "../../../assets/projects/mindgame.png";
import gamedash from "../../../assets/projects/game.png";
import portfolio from "../../../assets/projects/portfolio.png";
import animation from "../../../assets/projects/MPK Mini mk3 MIDI Controller (1).png";
import weather from "../../../assets/projects/weather.png";

export default function ProjectLayout() {
  const projectsData = [
    {
      id: 1,
      img: game,
      name: "Mind Game Js",
      tech: [
        {
          name: "Javascript",
          img: js,
        },
      ],
      live: "true",
      git: "https://github.com/tharinm/Mind-Game-JavaScript-",
      liveLink: "https://tharinm.github.io/Mind-Game-JavaScript-/",
    },
    {
      id: 2,
      img: animation,
      name: "Christmas Wish Animation",
      tech: [
        {
          name: "Css",
          img: css,
        },
      ],
      live: "true",
      git: "https://github.com/tharinm/CSS-Animation",
      liveLink: "https://tharinm.github.io/CSS-Animation/",
    },
    {
      id: 3,
      img: keyboard,
      name: "Akai Mini Keyboard",
      tech: [
        {
          name: "Javascript",
          img: js,
        },
      ],
      live: "true",
      git: "https://github.com/tharinm/AKAI-MPK-mini-Keyboard-JS",
      liveLink: "https://tharinm.github.io/AKAI-MPK-mini-Keyboard-JS/",
    },
    {
      id: 4,
      img: clean,
      name: "My Cleaners Web App",
      tech: [
        {
          name: "Bootsrap",
          img: bootsrap,
        },
        {
          name: "PHP",
          img: php,
        },
        {
          name: "MySQL",
          img: mysql,
        },
      ],
      live: false,
      git: "https://github.com/tharinm/Cleaning-Service-Booking-System-v7/tree/main",
    },
    {
      id: 5,
      img: freelance,
      name: "Freelancer Platform",
      tech: [
        {
          name: "React",
          img: react,
        },
        {
          name: "NodeJs",
          img: node,
        },
        {
          name: "MongoDb",
          img: mongo,
        },
      ],
      git: "https://github.com/tharinm/Freelance-Website---MERN",
    },
    {
      id: 6,
      img: weather,
      name: "Weather App",
      tech: [
        {
          name: "React",
          img: react,
        },
        {
          name: "NodeJs",
          img: node,
        },
        {
          name: "MongoDB",
          img: mongo,
        },
      ],
      live: "true",
      git: "https://github.com/tharinm/Weather-App",
      liveLink: "https://weather-f.onrender.com/",
    },
    {
      id: 7,
      img: fitness,
      name: "Fitness WebSite",
      tech: [
        {
          name: "React",
          img: react,
        },
        {
          name: "Material UI",
          img: mui,
        },
      ],
      live: "true",
      git: "https://github.com/tharinm/Fitness-Web-App-React-MUI",
      liveLink: "https://fitness-web-app-react-mui.vercel.app/",
    },
    {
      id: 8,
      img: lays,
      name: "Lay's Chips Website",
      tech: [
        {
          name: "Html",
          img: html,
        },
        {
          name: "CSS",
          img: css,
        },
        {
          name: "Tailwind",
          img: tailwind,
        },
      ],
      live: "true",
      git: "https://github.com/tharinm/Lays-Crisps-Website",
      liveLink: "https://lays-crisps-website.vercel.app/",
    },
    {
      id: 9,
      img: gamedash,
      name: "Gaming Dashboard",
      tech: [
        {
          name: "React",
          img: react,
        },
        {
          name: "Css",
          img: css,
        },
      ],
      live: "true",
      git: "https://github.com/tharinm/Gaming-Dashboard-React",
      liveLink: "https://gaming-dashboard-react-80m08lced-tharinm.vercel.app/",
    },
    {
      id: 10,
      img: portfolio,
      name: "My Portfolio",
      tech: [
        {
          name: "React",
          img: react,
        },
        {
          name: "Material UI",
          img: mui,
        },
      ],
      live: "true",
      liveLink: "https://th4rin.netlify.app/",
    },
  ];

  return (
    <div
      style={{ marginTop: "150px" }}
      data-aos="fade-up"
      data-aos-duration="3000"
      id="projects"
    >
      <Typography
        textAlign="center"
        variant="h5"
        sx={{
          color: "#00adb5",
          fontWeight: 500,
          fontFamily: "Getboreg Trial Only",
          fontSize: { xs: "18px", md: "25px" },
          marginBottom: { xs: "30px" },
        }}
      >
        P R O J E C T S & W O R K S
      </Typography>
      <Swiper
        effect={"coverflow"}
        grabCursor={true}
        centeredSlides={true}
        slidesPerView={"auto"}
        coverflowEffect={{
          rotate: 50,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: true,
        }}
        pagination={{ clickable: true }}
        modules={[EffectCoverflow, Pagination]}
        className="mySwiper"
        initialSlide={3}
      >
        {projectsData.map((val, key) => {
          return (
            <SwiperSlide key={val.id}>
              <SingleProjectCard data={val} />
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
}
